import { Flex, Image, Text } from "@chakra-ui/react";

type Props = {
  heading?: string;
  text?: string;
};
export function NotFound({ heading = "404", text = "Page Not Found" }: Props) {
  return (
    <Flex direction="column" justifyContent="center" gap={2} paddingTop={32}>
      <Image src="/404.svg" aria-label="404 Error" width="175" height="175" />
      <Text as="h1" fontSize="xl" textAlign="center" paddingTop={4}>
        {heading}
      </Text>
      <Text as="h2" fontSize="lg" textAlign="center" textColor="gray.500">
        {text}
      </Text>
    </Flex>
  );
}
